import script from "./QueryGreenWaysView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryGreenWaysView.vue?vue&type=script&setup=true&lang=js"

import "./QueryGreenWaysView.vue?vue&type=style&index=0&id=40c191cf&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c191cf"]])

export default __exports__